import React, { useState, useRef } from 'react';
import './VideoViewer.css';

type VideoViewerProps = {
  fileUrl: string;
  isFullScreen?: boolean;
};

const VideoViewer = ({ fileUrl, isFullScreen }: VideoViewerProps) => {
  const [isBuffering, setIsBuffering] = useState(false);
  const [hasError, setHasError] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handleOnLoadStart = () => {
    setIsBuffering(true);
  };

  const handleOnCanPlay = () => {
    setIsBuffering(false);
  };

  const handleOnError = () => {
    setHasError(true);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: isFullScreen ? 'flex-start' : 'center',
          alignItems: 'center',
          backgroundColor: 'transparent',
          border: 'none',
          boxShadow: 'none',
          borderRadius: 0,
          padding: '0',
          minHeight: 0,
          width: '100%',
        }}
      >
        <div className="video-viewer-wrapper" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
          {hasError ? (
            <div className="video-error">
              <p>Unable to load video. Please try again later.</p>
            </div>
          ) : (
            <>
              {isBuffering && <div className="video-loader">Buffering...</div>}
              <video
                ref={videoRef}
                controls
                onLoadStart={handleOnLoadStart}
                onCanPlay={handleOnCanPlay}
                onError={handleOnError}
              >
                <source src={fileUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoViewer;
